import XqLogoWhite from '../../assets/xq-logo-white.svg';
import XqLogoBlack from '../../assets/xq-logo-black.svg';
import './TranscriptsCoverPage.css';

type TranscriptsCoverPageVariant = 'by-student' | 'by-subject-area';

interface TranscriptsCoverPageProps {
  schoolName: string;
  variant: TranscriptsCoverPageVariant;
}

const VARIANT_CONFIG: Record<TranscriptsCoverPageVariant, { subtitle: string; logo: string }> = {
  'by-student': { subtitle: 'Transcripts by student', logo: XqLogoWhite },
  'by-subject-area': { subtitle: 'Transcripts by subject area', logo: XqLogoBlack },
};

const TranscriptsCoverPage = ({ schoolName, variant }: TranscriptsCoverPageProps) => {
  const { subtitle, logo } = VARIANT_CONFIG[variant];

  return (
    <div className={`cover-page cover-page--${variant}`}>
      <img src={logo} alt="XQ" className="cover-page-logo" />
      <div className="cover-page-body">
        <h1 className="cover-page-title">Student Journey Analysis</h1>
        <p className="cover-page-school">{schoolName}</p>
      </div>
      <p className="cover-page-subtitle">{subtitle}</p>
    </div>
  );
};

export default TranscriptsCoverPage;
